import {
    InventoryLocationInteractionMode
} from "./interaction";
import {drawInventoryLocationStyle} from "../../../../map/styles/inventory-locations";
import {Collection} from "ol";
import * as turf from "@turf/turf";
import {getArea} from "ol/sphere";
import * as $ from "jquery";
import {InventoryLocationInteractionMulti} from "./interaction-multi";
import {EpInventoryLocationAreas} from "../../../../map/layers/inventory-location-areas";
import {closeModal, openModal} from "../../../../utilities";

export class InventoryLocationInteractionThermalImagingAreas extends InventoryLocationInteractionMulti {
    areaType = null;
    /**
     * @param {InventoryLocationInteractionsHandler} handler
     */
    constructor(handler) {
        const layer = new EpInventoryLocationAreas(handler.epMap.map);
        layer.farStyle = null;
        layer.name = 'interaction_thermal_imaging_areas';

        handler.epMap.addCustomLayer(layer)

        super('thermal_imaging_areas', handler, layer);

        this.dictionary = {
            [InventoryLocationInteractionMode.DRAW]: 'Dodaj teren',
            deleteConfirm: 'Czy na pewno chcesz usunąć wybrany teren?',
            measurementTitle: 'Powierzchnia',
            measurementUnit: 'ha'
        };

        this.customCreateFeatureFromInput();
        this.updateAreaInfo();

        const modal = document.getElementById('drawAreaModal');
        modal.addEventListener('hide.bs.modal', () => {
            if(this.areaType === null) {
                this.toggleInteraction()
            }
        })

        modal.addEventListener('show.bs.modal', () => {
            $('select[name="area_area_type"]').val('').change();
        })

        $('#btnDrawArea').click(async () => {
            this.areaType = $('select[name="area_area_type"]').val();

            if(isNaN(parseInt(this.areaType))) {
                $('.error[data-for="area_area_type"]').text('Musisz wybrać rodzaj');
                this.zoneDepth = null;
                this.areaType = null;
                return;
            }

            if(![1, 2].includes(parseInt(this.areaType))) {
                $('.error[data-for="area_area_type"]').text('Wybrano niepoprawny rodzaj');
                this.areaType = null;
                return;
            }

            closeModal('#drawAreaModal')
        })
    }

    draw() {
        super.draw();
        let that = this;

        this.areaType = null;
        $('.error[data-for="area_area_type"]').text('');
        openModal('#drawAreaModal')

        this.handler.epMap.helpTooltip.set('Aby zakończyć rysowanie, kliknij w pierwszy dodany punkt.');
        this.addOlInteraction(
            this.epLayer.addDraw({
                noSource: true,
                style: drawInventoryLocationStyle,
                condition: (e) => {
                    let features = this.handler.epMap.getOlMap().getFeaturesAtPixel(e.pixel, {
                        layerFilter: (layer) => {
                            return layer === this.handler.epMap.boundaries.getLayer();
                        }
                    });
                    return features.length > 0;
                },
                end: function (e) {
                    e.feature.set('area_type', that.areaType)

                    let feature = that.addFeature(e.feature);
                    that.handler.setCurrentInteraction(null);

                    that.addToList(feature, 'Teren #' + that.features.length);
                    that.updateAreaInfo();
                }
            })
        )
    }

    edit() {
        super.edit();

        let that = this;
        let feature = this.features.find(feature => feature.get('id') === this.currentId);
        let previousCoordinates = feature.getGeometry().getCoordinates();

        this.addOlInteraction(
            this.epLayer.addEdit({
                style: drawInventoryLocationStyle,
                features: new Collection([feature]),
                end: function (e) {
                    let feature = e.features.item(0);

                    if (
                        !turf.booleanWithin(
                            turf.polygon(feature.getGeometry().getCoordinates()),
                            that.handler.epMap.boundaries.getBufferedBoundariesPolygon(2)
                        )
                    ) {
                        feature.getGeometry().setCoordinates(previousCoordinates);
                        return;
                    }

                    that.updateFeature(feature);
                    previousCoordinates = feature.getGeometry().getCoordinates();

                    that.updateAreaInfo();
                }
            })
        )
    }

    end(forced) {
        super.end(forced);

        this.updateAreaInfo();
    }

    updateAreaInfo() {
        const form = $('body').find('#addLocation, #editLocation');
        const areaInput = form.find('[name="area"]')
        const areaChangedManually = form.find('[name="area_changed_manually"]')

        let summaryArea = 0;
        let forestArea = 0;
        let fieldArea = 0;

        if (this.features.length) {
            if (parseInt(areaChangedManually.val()) === 0 || areaInput.val().length === 0) {
                for(let feature of this.features) {
                    let area = (getArea(feature.getGeometry()) / 10000);
                    summaryArea += area;

                    if(parseInt(feature.get('area_type')) === 2) {
                        fieldArea += area;
                    } else {
                        forestArea += area;
                    }

                    $(`[data-app-map_interaction_area="${this.name}"][data-app-feature_id="${feature.get('id')}"]`).text(area.toFixed(2))
                }

                areaInput.val(summaryArea.toFixed(2));
            }
        }

        $('[data-app-information_name="areas_area"] [data-app-information_value]').text(summaryArea.toFixed(2))
        $('[data-app-information_name="areas_forest_area"] [data-app-information_value]').text(forestArea.toFixed(2))
        $('[data-app-information_name="areas_field_area"] [data-app-information_value]').text(fieldArea.toFixed(2))

        // update inputs
        const fieldAreaInput = $('[name="field_area"]');
        const forestAreaInput = $('[name="forest_area"]');

        if(fieldAreaInput.length) {
            $(`[data-app-information_name="transects_field_area"] [data-app-information_value]`)
                .each(function() { fieldArea += parseFloat($(this).text()) })

            fieldAreaInput.val(fieldArea.toFixed(2))
        }

        if(forestAreaInput.length) {
            $(`[data-app-information_name="transects_forest_area"] [data-app-information_value]`)
                .each(function() { forestArea += parseFloat($(this).text()) })

            forestAreaInput.val(forestArea.toFixed(2))
        }

        if (parseInt(areaChangedManually.val()) === 0 || areaInput.val().length === 0) {
            $(`[data-app-information_name="transects_area"] [data-app-information_value]`)
                .each(function() { summaryArea += parseFloat($(this).text()) })

            areaInput.val(summaryArea.toFixed(2));
        }
    }

    addFeature(feature, id = null) {
        feature = super.addFeature(feature, id);

        // add area type input
        let areaTypeInput = $(`input[name="thermal_imaging_area_types[${feature.get('id')}]"]`);
        if(areaTypeInput.length === 0) {
            areaTypeInput = $(`
                    <input 
                        type="hidden" 
                        name="thermal_imaging_area_types[${feature.get('id')}]"
                        data-app-map_interaction_input="thermal_imaging_area_types"
                        value="${parseInt(feature.get('area_type'))}"
                        data-app-feature_id="${feature.get('id')}"
                   />
                `)

            $('#inputsContainer').append(areaTypeInput);
        }

        return feature;
    }

    customCreateFeatureFromInput(type = 'Polygon', style = null, name = null) {
        super.customCreateFeatureFromInput(type, style, name);

        for(let feature of this.features) {
            const areaTypeInput = $(`input[name="thermal_imaging_area_types[${feature.get('id')}]"]`);
            if(areaTypeInput.length !== 0) {
                feature.set('area_type', parseInt(areaTypeInput.val()))

                $(`[data-app-map_interaction_area_type][data-app-feature_id="${feature.get('id')}"]`)
                    .text(parseInt(areaTypeInput.val()) === 2 ? 'polny' : 'leśny')
                    .data('app-area_type', parseInt(areaTypeInput.val()))
            }
        }
    }

    addToList(feature, name) {
        if (!this.list) {
            return;
        }

        this.list.append(`
            <div data-app-map_interaction_element="${this.name}" data-app-feature_id="${feature.get('id')}" class="col-12">
                <label>${name}</label>
                <div class="row g-1">
                    <div class="col-4">
                        <button 
                            type="button"
                            data-app-map_interaction_edit_button="${this.name}" 
                            data-app-feature_id="${feature.get('id')}"
                            class="btn btn-primary w-100"
                        >
                            <i class="fas fa-pencil-alt"></i>
                        </button>
                    </div>
                    <div class="col-4">
                        <button 
                            type="button"
                            data-app-map_interaction_delete_button="${this.name}" 
                            data-app-feature_id="${feature.get('id')}"
                            class="btn btn-danger w-100"
                        >
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </div>
                <div class="row mt-2 g-1">
                    <div class="col-12">
                        Rodzaj obszaru: 
                        <a 
                            data-bs-toggle="tooltip"
                            title="kliknij, aby zmienić"
                            type="button"
                            class="btnEditAreaType link-underlined"
                            data-app-map_interaction_area_type="${this.name}"
                            data-app-feature_id="${feature.get('id')}"
                            data-app-area_type="${parseInt(feature.get('area_type') ?? 1)}"
                        >
                            ${parseInt(feature.get('area_type')) === 2 ? 'polny' : 'leśny'}
                        </a>
                    </div>
                    <div class="col-12">
                        ${this.dictionary.measurementTitle ?? 'Pomiar'}: 
                        <span 
                            data-app-map_interaction_area="${this.name}" 
                            data-app-feature_id="${feature.get('id')}"
                        >
                            
                        </span>${this.dictionary.measurementUnit ?? 'ha'}
                    </div>
                </div>
            </div>
        `);
    }
}